import Vue from 'vue';
import VueRouter from 'vue-router';

import BasicLayout from '@/components/layout/BasicLayout';
import EmptyLayout from '@/components/layout/EmptyLayout';

import store from '../store/index';

Vue.use(VueRouter);

export const routeName = {
  // 根路由
  root: 'Root',
  // 数据面板
  dashboard: 'Dashboard',
  // 订单量列表
  orderAmmount: 'orderAmmount',
  // 当日订单
  dayOrder: 'dayOrder',
  // 登录
  login: 'Login',
  // 订单管理
  order: 'Order',
  // 订单列表
  orderList: 'OrderList',
  // 订单详情
  orderDetail: 'OrderDetail',
  // 用户管理
  member: 'Member',
  // 用户列表
  memberList: 'MemberList',
  // 用户详情
  memberDetail: 'MemberDetail',
  // 用户有效订单列表
  memberOrderList: 'memberOrderList',
  // 系统设置
  setting: 'Setting',
  // 成员列表
  settingMember: 'SettingMember',
  // 物流服务列表
  serviceList: 'ServiceList',
  // 线路价格
  servicePriceList: 'ServicePriceList',
  // 线路价格设置
  servicePriceDetail: 'ServicePriceDetail',
  // 路线物品分类
  serviceGoodsCate: 'ServiceGoodsCate',
  // 管理权限
  settingAuthority: 'SettingAuthority',
  // 文案设置
  articleSetting: 'ArticleSetting',
  // 新增文案
  addArticle: 'AddArticle',
  // 公司信息设置
  companySetting: 'companySetting',
};

export const allRoutes = {
  [routeName.dashboard]: {
    path: 'dashboard',
    name: routeName.dashboard,
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Dashboard'),
    meta: {
      title: '首页',
    },
  },
  [routeName.order]: {
    path: 'order',
    name: routeName.order,
    component: EmptyLayout,
    redirect: '/order/purchase',
    meta: {
      title: '订单管理',
    },
  },
  [routeName.orderList]: {
    path: 'list',
    name: routeName.orderList,
    component: () => import(/* webpackChunkName: "order-list" */ '@/views/order/OrderList'),
    meta: {
      title: '订单列表',
    },
    children: [
      {
        path: 'detail',
        name: routeName.orderDetail,
        component: () => import(/* webpackChunkName: "order-detail" */ '@/views/order/OrderDetail'),
        meta: {
          title: '订单详情',
        },
      },
      {
        path: 'orderAmmount',
        name: routeName.orderAmmount,
        component: () => import(/* webpackChunkName: "dashboard/orderAmmount" */ '@/views/dashboard/orderAmmount'),
        meta: {
          title: '今日订单列表',
          hideBread: true,
        },
      },
      {
        path: 'dayOrder',
        name: routeName.dayOrder,
        component: () => import(/* webpackChunkName: "dashboard/orderAmmount" */ '@/views/dashboard/dayOrderList'),
        meta: {
          title: '订单列表',
          hideBread: true,
        },
      },
    ],
  },
  [routeName.member]: {
    path: 'member',
    name: routeName.member,
    component: EmptyLayout,
    redirect: '/member/list',
    meta: {
      title: '用户管理',
    },
  },
  [routeName.memberList]: {
    path: 'list',
    name: routeName.memberList,
    component: () => import(/* webpackChunkName: "member-list" */ '@/views/member/MemberList'),
    meta: {
      title: '用户列表',
    },
    children: [
      {
        path: 'detail',
        name: routeName.memberDetail,
        component: () => import(/* webpackChunkName: "member-detail" */ '@/views/member/MemberDetail'),
        meta: {
          title: '用户详情',
        },
      },
      {
        path: 'order-list',
        name: routeName.memberOrderList,
        component: () => import(/* webpackChunkName: "order-list" */ '@/views/order/OrderList'),
        meta: {
          title: '有效订单',
        },
      },
    ],
  },
  [routeName.setting]: {
    path: 'setting',
    name: routeName.setting,
    component: EmptyLayout,
    redirect: '/setting/channel',
    meta: {
      title: '系统设置',
    },
  },
  [routeName.serviceList]: {
    path: 'service',
    name: routeName.serviceList,
    component: () => import(/* webpackChunkName: "service-list" */ '@/views/service/ServiceList'),
    meta: {
      title: '线路价格',
    },
    children: [
      {
        path: 'price',
        name: routeName.servicePriceList,
        component: () => import(/* webpackChunkName: "service-list" */ '@/views/service/ServicePriceList'),
        meta: {
          title: '查看详情',
        },
      },
      {
        path: 'price-detail',
        name: routeName.servicePriceDetail,
        component: () => import(/* webpackChunkName: "service-list" */ '@/views/service/ServicePriceDetail'),
        meta: {
          title: '设置',
        },
      },
    ],
  },
  [routeName.serviceGoodsCate]: {
    path: 'serviceGoodsCate',
    name: routeName.serviceGoodsCate,
    component: () => import(/* webpackChunkName: "service-list" */ '@/views/serviceGoodsCate/list'),
    meta: {
      title: '线路物品分类',
    },
  },
  [routeName.settingMember]: {
    path: 'channel',
    name: routeName.settingMember,
    component: () => import(/* webpackChunkName: "setting-member" */ '@/views/setting/SettingMember'),
    meta: {
      title: '成员列表',
    },
  },
  [routeName.settingAuthority]: {
    path: 'withdraw',
    name: routeName.settingAuthority,
    component: () => import(/* webpackChunkName: "setting-authority" */ '@/views/setting/SettingAuthority'),
    meta: {
      title: '管理权限',
    },
  },
  [routeName.articleSetting]: {
    path: 'article',
    name: routeName.articleSetting,
    component: () => import(/* webpackChunkName: "article-setting" */ '@/views/article/ArticleList'),
    meta: {
      title: '文案设置',
    },
    children: [
      {
        path: 'add',
        name: routeName.addArticle,
        component: () => import(/* webpackChunkName: "article-setting" */ '@/views/article/AddArticle'),
        meta: {
          title: '查看详情',
        },
      },
    ],
  },
  [routeName.companySetting]: {
    path: 'companySetting',
    name: routeName.companySetting,
    component: () => import(/* webpackChunkName: "setting-authority" */ '@/views/setting/SettingCompany'),
    meta: {
      title: '公司信息设置',
    },
  },
};

const routes = [
  {
    path: '/login',
    name: routeName.login,
    component: () => import(/* webpackChunkName: "login" */ '@/views/auth/Login'),
  },
];

const whiteList = [routeName.login];
const router = new VueRouter({
  routes,
});

async function getTree() {
  await store.dispatch('asyncRouter/getTree');
  router.addRoutes([
    {
      path: '/',
      name: routeName.root,
      component: BasicLayout,
      redirect: '/dashboard',
      children: store.getters['asyncRouter/menus'],
      meta: {
        title: '首页',
      },
    },
  ]);
}

router.beforeEach(async (to, from, next) => {
  if (store.getters['user/loggedIn']) {
    try {
      const requests = [];

      const menusIsReady = store.getters['asyncRouter/menusIsReady'];
      // const hasUserInfo = store.getters['user/infoIsReady'];

      if (!menusIsReady) {
        requests.push(getTree());
      }

      // if (!hasUserInfo) {
      //   requests.push(store.dispatch('user/getInfo'));
      // }

      if (requests.length) {
        await Promise.all(requests);
      }

      if (!menusIsReady) {
        next({ ...to, replace: true });
      } else {
        next();
      }
    } catch (e) {
      store.dispatch('user/logout').then(() => {
        next({ name: routeName.login });
      });
    }
  } else {
    if (whiteList.includes(to.name)) {
      next();
    } else {
      next({ name: routeName.login });
    }
  }
});

export default router;
